import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="taxify"
              description="A.I. enabled portals for C.A.(chartered accountant) which help them in making the balanced sheets and all of their work more efficiently and helps them and new business to find their legal and best C.A. to manage their accounts and help them to save maximum tax in legal way."
              ghLink="https://github.com/Kushalsharma0702/Taxify.git"
              demoLink="https://orgtaxify.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="climate check 360"
              description="Introducing a personalized weather forecasting app with real-time updates and customized notifications for weather alerts. Stay informed about changing weather conditions, receive tailored alerts, and plan your day with confidence. Never be caught off guard by unexpected weather again."
              ghLink="https://github.com/dixitk941/climatecheck360.git"
              demoLink="http://climatecheck360.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="genz connect"
              description="Genzconnect is an integrated platform designed to streamline and enhance the remote classroom process. Tailored for recruiters and interviewees alike, Genzconnect provides an intuitive interface where candidates can effectively showcase their skills, and recruiters can conduct seamless interviews."
              ghLink="https://github.com/dixitk941/Genz.git"
              demoLink="https://genzconnect.vercel.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
